import { render, staticRenderFns } from "./priceCard.vue?vue&type=template&id=6fcd3e4c"
import script from "./priceCard.vue?vue&type=script&lang=js"
export * from "./priceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports